import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import MarginField from "./MarginField";

const EditDialog = ({ visible, onHide, onSubmit, loading, tariff }) => {
    const [marginPrice, setMarginPrice] = React.useState(null);
    const [insPercent, setInsPercent] = React.useState(0);

    React.useEffect(() => {
        if (visible && tariff) {
            setMarginPrice(tariff.marginPrice ?? null);
            setInsPercent(tariff.insPercent ?? 0);
        }
    }, [visible, tariff]);

    const handleSave = () => {
        if (marginPrice !== null && marginPrice < 0) return;
        if (insPercent < 0) return;
        onSubmit({ marginPrice, insPercent });
    };

    const footer = (
        <div>
            <Button label="Отмена" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Сохранить" icon="pi pi-check" loading={loading} onClick={handleSave} />
        </div>
    );

    if (!tariff) return null;

    return (
        <Dialog header={`Редактировать наценку #${tariff.id}`} visible={visible}
                style={{ width: "500px" }} modal onHide={onHide} footer={footer}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12">
                    <label>Платформа</label>
                    <InputText value={tariff.platform || ""} disabled />
                </div>
                <div className="p-field p-col-12">
                    <label>Клиент</label>
                    <InputText value={tariff.clientName || ""} disabled />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Перевозчик</label>
                    <InputText value={tariff.psCode || ""} disabled />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Услуга перевозчика</label>
                    <InputText value={tariff.psTypeCode || ""} disabled />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <MarginField value={marginPrice} onChange={setMarginPrice} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Страховка</label>
                    <InputNumber value={insPercent} mode="decimal" minFractionDigits={2} maxFractionDigits={3} min={0}
                                 onValueChange={e => setInsPercent(e.value ?? 0)} />
                </div>
            </div>
        </Dialog>
    );
};

export default EditDialog;
